export class GoogleMapModule {

	constructor() {
		this.pin = "/wp-content/themes/bz-ipco/assets/images/remake/red_map_pin.png";
		this.map = null;
		this.renderMap();
		this.setStyles();
		this.addListeners();
		this.timeOutId = null;
	}

	setStyles() {
		let stylePath = "/wp-content/themes/bz-ipco/assets/scripts/src/App/Map/snazzy-style.json";
		$.getJSON(stylePath, (data) => {
			this.map.setOptions({styles : data});
		});
	}

	renderMap() {
		this.map = new google.maps.Map(document.getElementById('ipco-map'), {
			center: this.getCenterCoords(),
			scrollwheel: false,
			disableDefaultUI: true,
			zoom: this.getZoomLevel(),
		});

		this.renderMarkers();
	}

	renderMarkers() {
		let url = '/wp-json/ipco/getAllCountries';
		let dataObj = {'countries' : 'gimme'};

		$.post(url, dataObj, (data) => {
			if (data.locations) {
				for (let i = 0; i < data.locations.length; i++) {
					this.placeMarker(data.locations[i]);
				}
			}
		});
	}

	placeMarker(location) {
		let marker = new google.maps.Marker({
			position: new google.maps.LatLng(location.latitude, location.longitude),
			map: this.map,
			draggable: false,
			clickable: false,
			icon : this.pin
		});
	}

	addListeners() {
		$(window).on('resize', () => {
			clearTimeout(this.timeOutId);

			this.timeOutId = setTimeout(() => {
				google.maps.event.trigger(this.map, 'resize');
				this.redrawMap();
			}, 50);
		});

		$("[data-zoom]").on('click', (e) => { this.zoomHandler(e) });
	}

	zoomHandler(e) {
		e.stopImmediatePropagation();

		let currentZoomLevel = this.map.getZoom();
		let zoomLevel = ($(e.currentTarget).data('zoom') == 'in') ? currentZoomLevel + 1 : currentZoomLevel - 1;

		this.map.setZoom(zoomLevel);
	};

	redrawMap() {
		this.map.setOptions({zoom : this.getZoomLevel()});
		this.map.setCenter(this.getCenterCoords());
	}

	getZoomLevel() {
		let vw = parseInt(window.innerWidth);

		if (vw > 1266) {
			return 3;
		}
		if (vw > 700) {
			return 2;
		}
		if (vw > 550) {
			return 2;
		}
		return 1;
	}

	getCenterCoords() {
		let vw = parseInt(window.innerWidth);

		if (vw > 1266) {
			return {
				lat: 50.634814,
				lng: 23.091370
			}
		}
		if (vw > 850) {
			return {
				lat: 48.864716, //paris france
				lng: 2.349014
			}
		}
		if (vw > 700) {
			return {
				lat: 43.151729, //Bulgaria
				lng: 23.882386
			}
		}
		return {
			lat: 21.722036, //Timbuktu mali
			lng: -3.715271
		}
	}

}
